<template>
	<treeBody :showLeft="!showDetail">
		<!-- 默认界面 -->
		<archivesDeviceTree slot="tree" :dataList="archivesGroupTree" @checkItem="nowGroup = $event" :groupCheckAble='true'
		 :autoSelectMethod="(item,index)=>nowGroup.name == undefined?item != undefined:item.id == nowGroup.id"></archivesDeviceTree>
		<div slot="body" style="width: 100%;height: 100%;" v-show="!showDetail">
			<div class="flexBetween" style="width: 100%;" :style="{height:($refs.topFilterBean == undefined?{}:$refs.topFilterBean).openFilter? 'calc(100% - 88px)':'calc(100% - 48px)'}">
				<div style="height: 100%;width: 100%;" class="card-box custom-scrollbar infoDiv">
					<div class="detailTitle flexBetween">
						<p>自助充值</p> 
					</div>
					<div class=" custom-scrollbar recharge-info" style="height: calc(100% - 41px - 62px - 40px);padding-bottom: 10px;">
						<p>宿舍名称</p>
						<input type="text" v-model="nowGroup.name" readonly>
						<p>当前余额</p>
						<input type="text" v-model="info.amount+'元'" readonly>
						<p>欠费金额</p>
						<input type="text" v-model="info.arrearsAmount+'元'" readonly>
						<button @click='move'>迁移</button>
					</div>
				</div>
			</div>
			
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import archivesDeviceTree from '@/components/module/tree/archivesDeviceTree.vue'
	import entityTypeTree from '@/components/module/tree/entityTypeTree.vue'
	
	export default {
		components: {
			treeBody,
			archivesDeviceTree,
			entityTypeTree
		},
		data() {
			return {
				nowGroup: {}, //当前选中的区域
				nowType: undefined, //当前选中的设备类型
				showDetail: false,
				info: {
					name: '测试',
					arrearsAmount: '100.00',
					amount: '2.00',
				}
			}
		},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowUnitArchivesTree() {
				//当前单位可以查看的台账设备树
				if (isempty(this.nowUnit)) {
					return undefined
				}
				return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
			},
			archivesGroupTree() {
				if (this.nowUnitArchivesTree == undefined) {
					return []
				}
				//过滤掉设备
				var filterList = list => {
					var nList = []
					if(list){
						for (var i = 0, len = list.length; i < len; i++) {
							var item = list[i]
							if (item.entityName == 'AppClassType') {
								if (item.hasOwnProperty("next")) {
									item.next = filterList(item.next)
								}
								nList.push(item)
								break
							}
						}
					}
					return nList
				}
				return filterList([copy(this.nowUnitArchivesTree)])
			},
		},
		watch: {
			nowType (nv, ov){
				this.info.name = nv.typeName
			}
		},
		methods: {
			move(){
				this.$dialogMethod.showMessage("无有效接口!")
			}
		}
	}
</script>

<style>
	.infoDiv {
		padding: 0 10px;
		width: 50%;
		height: 100%;
		border-right: silver dashed 1px;
	}
	
	.detailTitle {
		font-weight: bold;
		height: 25px;
		color: #007FCC;
		border-bottom: silver dashed 1px;
		padding: 10px 0;
		width: 100%;
	}
	
	.detailTitle>p {
		font-weight: bold;
		font-size: 20px;
	}
	
	.recharge-info {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		width: 30%;
	}
	
	.recharge-info>p {
		padding: 10px 0;
		font-size: .12rem;
	}
	
	.recharge-info>button{
		width: 30%;
		padding: 5px 10px;
		margin: 10px auto;
		border-radius: 5px;
		background: #0066FF;
		color: white;
	}
</style>
